module.exports = __webpack_public_path__ + "img/qrcode.2b697b7f.png";